module.exports = __webpack_public_path__ + "01_short_gold.705ce06a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/01_short_gold.png
// module id = zaQ3
// module chunks = 0